import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../axios";
import { notify } from "../../../util/helpers";

const initialState = {
  assessmentsLoading: false,
  defaultAssessmentsLoading: false,
  createAssessmentLoading: false,
  deleteAssessmentLoading: false,
  recentAssessments: {},
  assessmentsData: {},
  assessmentTypes: [],
  defaultAssessmentData: [],
  pendingAssessmentsData: [],
  dbtLoading: false,
  dbterror: false,
  dbtData: [],
  sdohData: {},
  sdohLoading: false,
};

export const fetchPendingAssessmentsLogic = createAsyncThunk(
  "patient/assessments/pending",
  (id) => {
    return axiosInstance.get(
      "/api/patient-assessment/get-pending-assessments/",
      {
        headers: {
          Authorization: `JWT ${localStorage.access}`,
          "Content-Type": "application/json",
        },
      }
    );
  }
);

export const collectCaregiverAnswers = (payload) => {
  return axiosInstance
    .post("/api/patient-assessment/collect-answers/", JSON.stringify(payload), {
      headers: {
        Authorization: `JWT ${localStorage.access}`,
        "Content-Type": "application/json",
      },
    })
    .then()
    .catch();
};

export const fetchRecentAssessmentsLogic = createAsyncThunk(
  "patient/assessments/recent",
  (id) => {
    let config = {
      method: "post",
      url: "/api/patient-assessment/assessment-results-recent/",
      headers: {
        Authorization: `JWT ${localStorage.access}`,
      },
      data: JSON.stringify({
        patient_id: id,
      }),
    };
    return axiosInstance.request(config);
  }
);

export const fetchDefaultAssessmentsLogic = createAsyncThunk(
  "schedulable-assessment",
  (clinicPin) => {
    return axiosInstance.get(
      `/api/schedulable-assessment/?clinic_pin=${clinicPin}`,
      {
        headers: {
          Authorization: `JWT ${localStorage.access}`,
          "Content-Type": "application/json",
        },
      }
    );
  }
);
export const deleteAssessmentByIdLogic = createAsyncThunk(
  "schedulable-assessment/delete",
  (id) => {
    return axiosInstance.delete(`/api/schedulable-assessment/${id}/`, {
      headers: {
        Authorization: `JWT ${localStorage.access}`,
      },
    });
  }
);

export const createAssessmentLogic = createAsyncThunk(
  "patient-assessment/create-schedulable-assessment",
  (payload) => {
    return axiosInstance.request({
      method: "post",
      // https://devapi.rosehealth.com/api/patient-assessment/create-schedulable-assessment/
      url: "/api/patient-assessment/create-schedulable-assessment/",
      headers: {
        Authorization: `JWT ${localStorage.access}`,
      },
      data: JSON.stringify(payload),
    });
  }
);

export const fetchAllAssessmentsLogic = createAsyncThunk(
  "patient/assetments/all",
  (payload) => {
    /*payload = {
    "patient_id": "1843",
    "start_date": "2023-05-01",
    "end_date": "2023-05-05"
    }*/
    return axiosInstance.request({
      method: "post",
      // https://api.rosehealth.com/api/patient-assessment/assessment-results/
      url: "/api/patient-assessment/assessment-results/",
      headers: {
        Authorization: `JWT ${localStorage.access}`,
      },
      data: JSON.stringify(payload),
    });
  }
);

export const fetchDBTAssessmentsLogic = createAsyncThunk(
  "patient/assessments/DBT",
  (params) => {
    let url = "/api/dbtassessments/date-range";
    return axiosInstance.get(url, {
      headers: {
        Authorization: `JWT ${localStorage.access}`,
        "Content-Type": "application/json",
      },
      params: params,
    });
  }
);

export const fetchAssessmentTypesLogic = createAsyncThunk(
  "patient/assessments/types",
  (params = { is_schedulable: 1, is_caregiver: 0 }) => {
    return axiosInstance.get("/api/assessment/", {
      headers: {
        Authorization: `JWT ${localStorage.access}`,
      },
      params: params,
    });
  }
);

export const fetchScheduledAssessmentsLogic = createAsyncThunk(
  "patient/assessments/single",
  (patientID) => {
    return axiosInstance.get(`/api/assessment-schedule/?patient=${patientID}`, {
      headers: { Authorization: `JWT ${localStorage.access}` },
    });
  }
);

// export const fetchSDOHPatientResults = async (patientID, labels = "False") => {
//   return axiosInstance
//     .get(`/api/sdoh-patient-answers/`, {
//       headers: { Authorization: `JWT ${localStorage.access}` },
//       params: {
//         patient_id: patientID,
//         labels: labels,
//       },
//     })
//     .then()
//     .catch();
// };

export const fetchSDOHPatientResultsLogic = createAsyncThunk(
  "patient/assessments/sdoh",
  (patientID) => {
    return axiosInstance.get(`/api/sdoh-patient-answers/`, {
      headers: { Authorization: `JWT ${localStorage.access}` },
      params: {
        patient_id: patientID,
        labels: "True",
      },
    });
  }
);

//DBT Details api calls
export const fetchDBTDetailsLogic = async (params) => {
  return axiosInstance
    .get(`api/v2/dbtassessments`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.access}`,
      },
      params: params,
    })
    .then()
    .catch();
};
export const fetchDBTChartDataLogic = async (params) => {
  return axiosInstance
    .get(`api/dbtassessments`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.access}`,
      },
      params: params,
    })
    .then()
    .catch();
};
export const fetchAssessmentCountPerDayLogic = async (payload) => {
  return axiosInstance
    .post(
      `api/aco-executive-stats/get-assessment-type-count-per-day/`,
      JSON.stringify(payload),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.access}`,
        },
      }
    )
    .then()
    .catch();
};
export const fetchDepressionRemission = async (payload) => {
  return axiosInstance
    .post(
      `api/aco-executive-stats/get-depression-remission/`,
      JSON.stringify(payload),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.access}`,
        },
      }
    )
    .then()
    .catch();
};
export const fetchFlagTypeCountPerDay = async (payload) => {
  return axiosInstance
    .post(
      `api/aco-executive-stats/get-patient-flag-type-count-per-day/`,
      JSON.stringify(payload),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.access}`,
        },
      }
    )
    .then()
    .catch();
};
export const fetchImprovementForAssessment = async (payload) => {
  return axiosInstance
    .post(
      `api/aco-executive-stats/get-improvement-for-assessment/`,
      JSON.stringify(payload),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.access}`,
        },
      }
    )
    .then()
    .catch();
};
//patient statement api call
export const fetchPateintAssessmentsLogic = async (value) => {
  return axiosInstance
    .get("api/assessment-schedule/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.access}`,
      },
      params: {
        patient: String(value),
      },
    })
    .then()
    .catch();
};
export const fetchCaregiverRecentAssessmentLogic = async(id)=>{
  return axiosInstance
  .post ("/api/patient-assessment/assessment-results-recent/", JSON.stringify({ patient_id: id},),{
    headers: {
      "Content-Type": "application/json",
      Authorization: `JWT ${localStorage.access}`,
    },
})
.then()
.catch();
};

export const fetchCaregiverAllAssessmentsLogic = async(payload)=>{
  /*payload = {
    "patient_id": "1843",
    "start_date": "2023-05-01",
    "end_date": "2023-05-05"
    }*/
  return axiosInstance
  .post ( "/api/patient-assessment/assessment-results/", JSON.stringify(payload),{
    headers: {
      "Content-Type": "application/json",
      Authorization: `JWT ${localStorage.access}`,
    },
})
.then()
.catch();

};

export const editPateintAssessmentsLogic = async (assessmentId, payload) => {
  return axiosInstance
    .patch(
      `/api/assessment-schedule/${assessmentId}/`,
      JSON.stringify(payload),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.access}`,
        },
      }
    )
    .then()
    .catch();
};

export const deletePateintAssessmentsLogic = async (assessmentId) => {
  return axiosInstance
    .delete(`/api/assessment-schedule/${assessmentId}/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.access}`,
      },
    })
    .then()
    .catch();
};

export const createPateintAssessmentsLogic = async (payload) => {
  return axiosInstance
    .post("/api/assessment-schedule/", JSON.stringify(payload), {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.access}`,
      },
    })
    .then()
    .catch();
};

const assessmentAPICalls = {
  //* PENDING ASSESSMENTS DATA PROMISES
  [fetchPendingAssessmentsLogic.pending]: (state) => {
    state.assessmentsLoading = true;
  },
  [fetchPendingAssessmentsLogic.fulfilled]: (state, { payload }) => {
    state.assessmentsLoading = false;
    state.pendingAssessmentsData = payload.data;
  },
  [fetchPendingAssessmentsLogic.rejected]: (state) => {
    state.assessmentsLoading = false;
  },
  //* RECENT ASSESSMENTS DATA PROMISES
  [fetchRecentAssessmentsLogic.pending]: (state) => {
    state.assessmentsLoading = true;
  },
  [fetchRecentAssessmentsLogic.fulfilled]: (state, action) => {
    state.recentAssessments = action.payload.data;
    state.assessmentsLoading = false;
  },
  [fetchRecentAssessmentsLogic.rejected]: (state, action) => {
    state.assessmentsLoading = false;
  },

  //*DBT ASSESSMENTS DATA PROMISES
  [fetchDBTAssessmentsLogic.pending]: (state) => {
    state.dbtLoading = true;
    state.dbterror = false;
  },
  [fetchDBTAssessmentsLogic.fulfilled]: (state, { payload }) => {
    state.dbtData = payload.data;
    state.dbterror = false;
    state.dbtLoading = false;
  },
  [fetchDBTAssessmentsLogic.rejected]: (state, action) => {
    state.dbtLoading = false;
    state.dbterror = true;
  },

  //* ALL ASSESSMENTS DATA PROMISES
  [fetchAllAssessmentsLogic.pending]: (state) => {
    state.assessmentsLoading = true;
  },
  [fetchAllAssessmentsLogic.fulfilled]: (state, { payload }) => {
    state.assessmentsLoading = false;
    state.assessmentsData = payload.data;
  },
  [fetchAllAssessmentsLogic.rejected]: (state, action) => {
    state.assessmentsLoading = false;
  },
  [fetchSDOHPatientResultsLogic.pending]: (state) => {
    state.sdohLoading = true;
  },
  [fetchSDOHPatientResultsLogic.fulfilled]: (state, { payload }) => {
    if (payload?.status === 200) {
      state.sdohData = payload?.data?.data;
    } else if (payload?.status === 204) {
      state.sdohData = [];
    }
    state.sdohLoading = false;
  },
  [fetchSDOHPatientResultsLogic.rejected]: (state, action) => {
    state.sdohLoading = false;
  },
  //* FETCH DEFAULT ASSESSMENTS PROMISES
  [fetchDefaultAssessmentsLogic.pending]: (state) => {
    state.defaultAssessmentsLoading = true;
  },
  [fetchDefaultAssessmentsLogic.fulfilled]: (state, { payload }) => {
    state.defaultAssessmentData = payload.data;
    state.defaultAssessmentsLoading = false;
  },
  [fetchDefaultAssessmentsLogic.rejected]: (state, action) => {
    state.defaultAssessmentData = {};
    state.defaultAssessmentsLoading = false;
  },
  //*  DELETE ASSESSMENT BY ID PROMISES
  [deleteAssessmentByIdLogic.pending]: (state) => {
    state.deleteAssessmentLoading = true;
  },
  [deleteAssessmentByIdLogic.fulfilled]: (state, action) => {
    state.deleteAssessmentLoading = false;
    let temp = [...state.defaultAssessmentData];
    temp = temp.filter((item) => {
      return item.id !== action.meta.arg;
    });
    state.defaultAssessmentData = temp;
  },
  [deleteAssessmentByIdLogic.rejected]: (state, action) => {
    state.deleteAssessmentLoading = false;
    notify("Something went wrong!", "error");
  },
  //* CREATE ASSESSMENT PROMISES
  [createAssessmentLogic.pending]: (state) => {
    state.createAssessmentLoading = true;
  },
  [createAssessmentLogic.fulfilled]: (state, { payload }) => {
    state.createAssessmentLoading = false;
    state.defaultAssessmentData = [
      ...state.defaultAssessmentData,
      payload.data,
    ];
  },
  [createAssessmentLogic.rejected]: (state, action) => {
    state.createAssessmentLoading = false;
    notify("Something went wrong!", "error");
  },

  //* FETCH ASSESSMENT TYPES PROMISES
  [fetchAssessmentTypesLogic.pending]: (state) => {},
  [fetchAssessmentTypesLogic.fulfilled]: (state, { payload }) => {
    state.assessmentTypes = payload.data;
  },
  [fetchAssessmentTypesLogic.pending]: (state, action) => {},

  //* FETCH SCHEDULED ASSESSMENTS FOR SINGLE PATIENT PROMISES
  [fetchScheduledAssessmentsLogic.pending]: (state) => {
    state.assessmentsLoading = true;
  },
  [fetchScheduledAssessmentsLogic.fulfilled]: (state, { payload }) => {
    state.assessmentsLoading = false;
    state.scheduledAssessments = payload.data;
  },
  [fetchScheduledAssessmentsLogic.rejected]: (state, action) => {
    state.assessmentsLoading = false;
  },
};

const assessmentSlice = createSlice({
  name: "assessment",
  initialState,
  extraReducers: {
    ...assessmentAPICalls,
  },
  reducers: {
    fetchPendingAssessments: fetchPendingAssessmentsLogic,
    recentAssessments: fetchRecentAssessmentsLogic,
    assessmentTypes: fetchAssessmentTypesLogic,
    scheduledAssessments: fetchScheduledAssessmentsLogic,
    defaultAssessments: fetchDefaultAssessmentsLogic,
    deleteAssessmentById: deleteAssessmentByIdLogic,
    createAssessment: createAssessmentLogic,
    fetchDBTAssessments: fetchDBTAssessmentsLogic,
    fetchSDOHPatientResults: fetchSDOHPatientResultsLogic,
  },
});

export const {
  fetchPendingAssessments,
  recentAssessments,
  assessmentTypes,
  scheduledAssessments,
  defaultAssessments,
  deleteAssessmentById,
  createAssessment,
  fetchDBTAssessments,
  fetchSDOHPatientResults,
} = assessmentSlice.actions;
export default assessmentSlice.reducer;